import { useAuth0 } from "@auth0/auth0-react";
import Dialog from "@material-ui/core/Dialog";
import FinanceSetting, { default as FinancialSetting } from "Lib/API/FinanceSetting/FinanceSetting";
import Editor from "components/Editor/Editor";
import ConfirmSaveTemplateModal from "components/SendLetter/ConfirmSaveTemplateModal/ConfirmSaveTemplateModal";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { setSelectedTemplate } from "services/api/communication";
import { Footer } from "../Footer/Footer";
import { CampainName, EditTitle, Title } from "./Theme";
export const EditTemplate = ({
  onNext,
  formik,
  onBack,
  setViewTemplate,
}) => {
  const { selectedTemplate } = useSelector(
    (state) => state.communication
  );
  const dispatch = useDispatch()
  const [htmlContent, setHtmlContent] = useState(selectedTemplate?.htmlContent);
  const [jsonContent, setJsonContent] = useState(selectedTemplate?.jsonContent || {});
  const [tokenList, setTokenList] = useState([]);
  const { getAccessTokenSilently } = useAuth0();
  const emailEditorRef = useRef({ projectId: 195575 });
  const [enableEdit, setEnableEdit] = useState(true);
  const [saveTemplateLoading, setSaveTemplateLoading] = useState(false);
  const [updateTemplateLoading, setUpdateTemplateLoading] = useState(false);
  const [openConfirmSaveTemplateModal, setOpenConfirmSaveTemplateModal] = useState(false);

  const updateTemplate = async () => {
    setUpdateTemplateLoading(true);
    const token = await getAccessTokenSilently();

    const data = {
      // content: replacedHtml,
      htmlContent: htmlContent,
      jsonContent: jsonContent,
      replyTo: selectedTemplate?.replyTo || null,
      useDefault: selectedTemplate?.useDefault,
    };
    try {
      const response = await FinanceSetting.updateTemplateById(
        token,
        selectedTemplate?._id,
        data
      );
      dispatch(setSelectedTemplate(response?.result))
      setUpdateTemplateLoading(false);
      toastr.success("Template updated successfully");
      console.log('response?.result', response?.result)
      onNext()
    } catch (error) {
      toastr.error("Error", error?.data?.message ?? "Something went wrong");
      setUpdateTemplateLoading(false);
    }
  };
  const saveTemplateHandler = async () => {
    setSaveTemplateLoading(true);
    const token = await getAccessTokenSilently();
    const data = {
      type: "communication",
      addLogo: false,
      title:formik?.values?.templateName,
      replyTo: selectedTemplate?.replyTo,
      content: htmlContent,
      useDefault: selectedTemplate?.useDefault,
      jsonContent,
      htmlContent,
    };

    try {
      const response = await FinancialSetting.createTemplate(token, data);
      setSaveTemplateLoading(false);
      toastr.success("Template saved successfully");
      setOpenConfirmSaveTemplateModal(false);
    } catch (error) {
      toastr.error("Error", error?.data?.message ?? "Somthing Went Wrong");
      setSaveTemplateLoading(false);
    }
  };
  const buttons = [
    {
      name: "Previous",
      action: () => {
        setViewTemplate(true);
        onBack();
      },
      isDisabled: false,
      type: "secondary",
      marginRight: "42rem",
      width:'100px',
      variant : "primary-outline"
    },
    {
      name: "Save as a new",
      action: () => {
        setOpenConfirmSaveTemplateModal(true)
      },
      isDisabled: false,
      type: "secondary",
      loading:saveTemplateLoading,
      width:'150px',
      variant : "primary"
    },
    {
      name: "Save and continue",
      action: () => {
        updateTemplate()
      },
      isDisabled: false,
      type: "primary",
      loading:updateTemplateLoading,
      width:'150px',
      variant : "primary"
    },
  ];

  const getTemplateTokens = async (type) => {
    const fileType = type;
    const token = await getAccessTokenSilently();
    try { 
      const response = await FinanceSetting.getTemplateTokens(token, fileType);
      const tokens = response?.result;
      setTokenList(tokens);
    } catch (error) {
      toastr.error("Error", error?.data?.message ?? "Something went wrong");
    }
  };

  useEffect(() => {
    getTemplateTokens("communication");
  }, []);
  return (
    <div style={{ marginLeft: "-9%" }}>
      <EditTitle>
        <Title>
          Edit Template
          <span>Edit your selected template</span>
        </Title>
        <CampainName>{formik.values?.campainName}</CampainName>
      </EditTitle>
      <Dialog
        open={openConfirmSaveTemplateModal}
        onClose={() => {
            setOpenConfirmSaveTemplateModal(false);
            formik.setFieldValue("templateName", "");
        }}
        PaperProps={{
          style: {
            width: "600px",
            height: "fit-content",
            overflow: "hidden",
            borderRadius: "22px",
            maxWidth: "600px",
          },
        }}
        fullWidth
        maxWidth={"md"}
      >
        <ConfirmSaveTemplateModal
          formik={formik}
          field="templateName"
          open={openConfirmSaveTemplateModal}
          saveTemplate={saveTemplateHandler}
          createTemplate={()=>{
            setOpenConfirmSaveTemplateModal(false)
            formik.setFieldValue("templateName", "");
        }}
          saveTemplateLoading={saveTemplateLoading}
          closeModal={() => {
            setOpenConfirmSaveTemplateModal(false);
            formik.setFieldValue("templateName", "");
          }}
        />
      </Dialog>
      <Editor
        setJsonContent={setJsonContent}
        setHtmlContent={setHtmlContent}
        preview={enableEdit}
        jsonContent={jsonContent}
        tokenList={tokenList}
        emailEditorRef={emailEditorRef}
      />
      <br />
      <Footer buttons={buttons} type="My template"/>
      <br />
    </div>
  );
};
